import { NgModule, ModuleWithProviders } from '@angular/core';

import { PersonDetailsService } from 'src/app/shared/services/person-details.service';
import { AppInitializationService } from 'src/app/shared/services/app-initialization.service';
import { DisclaimerService } from 'src/app/shared/services/disclaimer.service';
import { AttributeService } from 'src/app/shared/services/attribute.service';
import { Auth0Service } from 'src/app/shared/services/auth0.service';
import { TeamService } from 'src/app/shared/services/team.service';
import { SnackBarService } from 'src/app/shared/services/snackbar.service';
import { ApplicationService } from 'src/app/shared/services/application.service';
import { FormService } from 'src/app/shared/services/form.service';
import { EmailCustomizationService } from 'src/app/shared/services/email-customization.service';
import { ProgressService } from 'src/app/shared/services/progress.service';
import { SurveyService } from './services/survey.service';
import { TeamFormService } from './services/team-form.service';
import { AttributeGroupService } from './services/attribute-group.service';
import { AppConfigService } from './services/app-config.service';
import { EmailPreparationService } from './services/email-preparation.service';
import { WorkspaceService } from './services/workspace.service';
import { SafeHtmlService } from './services/safe-html.service';

@NgModule({})
export class SharedServicesModule {
  static forRoot(): ModuleWithProviders<SharedServicesModule> {
    return {
      ngModule: SharedServicesModule,
      providers: [
        AttributeGroupService,
        PersonDetailsService,
        AppInitializationService,
        AppConfigService,
        FormService,
        DisclaimerService,
        AttributeService,
        Auth0Service,
        TeamService,
        SnackBarService,
        ApplicationService,
        EmailCustomizationService,
        ProgressService,
        SurveyService,
        TeamFormService,
        EmailPreparationService,
        WorkspaceService,
        SafeHtmlService
      ]
    };
  }
}
